<div class="card">
  <p class="title">{{ text() }}</p>
  <hr />

  <div class="chart-wrapper">
    <canvas
      baseChart
      #chartData
      [data]="barChartData"
      [options]="barChartOptions"
      [legend]="barChartLegend"
      [type]="'bar'"
      [plugins]="pieChartPlugins"
    >
    </canvas>
  </div>

  @if (referenceValue() !== null) {
    <div class="reference-legend">
      <span class="reference-legend__line"></span>
      <span>{{ referenceLabel() || 'Linha de referência' }}: {{ referenceValue() }}%</span>
    </div>
  }
</div>
